import { getSubscriptionAccessLevel, checkSoftlockStatus } from 'lib/utils';
import { FORBIDDEN_ROUTES } from 'constants/subscriptionAccess';

const checkRouteAccess = store => (route, checkTrial = true, ldFlags = undefined) => {
  const state = store.getState();
  const currentSchool = state.currentUser ? state.currentUser.data.current_school : null;

  if (!currentSchool || !route) {
    return true;
  }

  let acc = getSubscriptionAccessLevel(currentSchool, checkTrial);

  if (ldFlags !== undefined && ldFlags['subscription-softlock']) {
    const softlockAcc = checkSoftlockStatus(currentSchool);
    if (softlockAcc !== undefined && softlockAcc !== null) {
      acc = softlockAcc;
    }
  }

  const routes = FORBIDDEN_ROUTES[acc] || [];

  return routes.every(r => route.indexOf(r) !== 0);
};

export default checkRouteAccess;
